/*
Copyright 2022 The Matrix.org Foundation C.I.C.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

import { ServerControlledNamespacedValue } from "../NamespacedValue";

/**
 * https://github.com/matrix-org/matrix-doc/pull/3773
 *
 * @experimental
 */
export const UNREAD_THREAD_NOTIFICATIONS = new ServerControlledNamespacedValue(
    "unread_thread_notifications",
    "org.matrix.msc3773.unread_thread_notifications");
